export const PERMISOS = {
    VIGIFLOW: {
        /** Ver detalle de archivos cargados (logs, registros procesados) */
        VER_DETALLE: "VIGIFLOW.VER_DETALLE",
    },
};
